




























import { Component, Vue } from "vue-property-decorator";
import QuickEdit from "./quickEdit/QuickEdit.vue";
import ConfigEdit from "./configEdit/ConfigEdit.vue";
import { IElementType } from '@/data/ElementTypeModel';

@Component({
    components: {
        "quick-edit": QuickEdit,
        "config-edit": ConfigEdit
    }
})
export default class App extends Vue {

}
